import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { House, FileText, QrCode, SignOut, ArrowSquareOut, Key } from "@phosphor-icons/react";
import { toast } from "sonner";
import ChangePasswordModal from "@/components/ChangePasswordModal";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [showChpwd, setShowChpwd] = useState(false);

  const items = [
    { to: "/admin", icon: <House size={16} />, label: "Dashboard", end: true, testid: "nav-dashboard" },
    { to: "/admin/pages", icon: <FileText size={16} />, label: "Pages", testid: "nav-pages" },
    { to: "/admin/qr", icon: <QrCode size={16} />, label: "QR Codes", testid: "nav-qr" },
  ];

  const doLogout = async () => {
    await logout();
    toast.success("Signed out");
    nav("/login");
  };

  return (
    <div className="shell">
      <aside className="sidebar" data-testid="admin-sidebar">
        <div style={{ padding: "0 24px 24px", display: "flex", alignItems: "center", gap: 10, borderBottom: "1px solid var(--border)" }}>
          <div style={{ width: 28, height: 28, background: "#000", display: "grid", placeItems: "center" }}>
            <QrCode size={16} color="#fff" weight="bold" />
          </div>
          <span className="font-display" style={{ fontWeight: 900, fontSize: 16, letterSpacing: "-0.02em" }}>7AuraDigital</span>
        </div>
        <nav style={{ marginTop: 16 }}>
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.testid}
              className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}
            >
              {it.icon} {it.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: 16, borderTop: "1px solid var(--border)", background: "#fff" }}>
          <div style={{ fontSize: 12, color: "var(--text-2)" }}>{user?.email}</div>
          <button onClick={() => setShowChpwd(true)} className="btn btn-ghost" data-testid="change-password-btn"
            style={{ width: "100%", marginTop: 8, justifyContent: "flex-start" }}>
            <Key size={14} /> Change password
          </button>
          <button onClick={doLogout} className="btn btn-ghost" data-testid="signout-btn"
            style={{ width: "100%", marginTop: 4, justifyContent: "flex-start" }}>
            <SignOut size={14} /> Sign out
          </button>
        </div>
      </aside>
      <main className="main">
        <div className="topbar">
          <div className="overline">Admin Console</div>
          <a href="/" target="_blank" rel="noreferrer" className="btn btn-ghost" data-testid="view-public-site">
            <ArrowSquareOut size={14} /> View public site
          </a>
        </div>
        <div className="page-pad">
          <Outlet />
        </div>
      </main>
      {showChpwd && <ChangePasswordModal onClose={() => setShowChpwd(false)} />}
    </div>
  );
}
